import c0 from './modal_controller';
import c1 from './tooltip_controller';
export const definitions = [
	{identifier: 'modal', controllerConstructor: c0},
	{identifier: 'tooltip', controllerConstructor: c1},
];
